import React, { useState, useSyncExternalStore } from 'react';
import { Navigate } from 'react-router-dom';
import { LOGIN, PROFILE } from '../routes/paths';
import { getAuthToken, subscribeToAuth } from '../utils/authSession';

function AccountSetupRoute({ children }) {
  const token = useSyncExternalStore(subscribeToAuth, getAuthToken, () => null);
  // Let an in-progress signup finish its own event/profile navigation.
  const [alreadyComplete] = useState(() => localStorage.getItem('isCompleteAccount') === 'true');
  const pendingToken = sessionStorage.getItem('pendingAuthToken');
  if (!token && !pendingToken) return <Navigate to={LOGIN} replace />;
  if (alreadyComplete && !pendingToken) return <Navigate to={PROFILE} replace />;
  return children;
}

export default AccountSetupRoute;
